export const API_ROUTES = {
  AUTH: {
    REGISTER: '/api/auth/register',
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    VERIFY_EMAIL: '/api/auth/verify-email',
    VERIFY_PHONE: '/api/auth/verify-phone',
    SEND_VERIFICATION: '/api/auth/send-verification',
    ME: '/api/auth/me',
  },
  USERS: {
    PROFILE: (id: string) => `/api/users/${id}`,
    UPDATE: '/api/users/me',
  },
  TOOLS: {
    LIST: '/api/tools',
    CREATE: '/api/tools',
    DETAIL: (id: string) => `/api/tools/${id}`,
    UPDATE: (id: string) => `/api/tools/${id}`,
    DELETE: (id: string) => `/api/tools/${id}`,
    SEARCH: '/api/tools/search',
    MY_TOOLS: '/api/tools/mine',
    UPLOAD_IMAGE: (id: string) => `/api/tools/${id}/images`,
  },
  RENTALS: {
    LIST: '/api/rentals',
    CREATE: '/api/rentals',
    DETAIL: (id: string) => `/api/rentals/${id}`,
    ACCEPT: (id: string) => `/api/rentals/${id}/accept`,
    REJECT: (id: string) => `/api/rentals/${id}/reject`,
    CONFIRM_PICKUP: (id: string) => `/api/rentals/${id}/pickup`,
    CONFIRM_RETURN: (id: string) => `/api/rentals/${id}/return`,
    MY_BORROWING: '/api/rentals/borrowing',
    MY_LENDING: '/api/rentals/lending',
  },
  PAYMENTS: {
    CREATE_INTENT: '/api/payments/create-intent',
    WEBHOOK: '/api/payments/webhook',
  },
  MESSAGES: {
    LIST: (rentalId: string) => `/api/rentals/${rentalId}/messages`,
    SEND: (rentalId: string) => `/api/rentals/${rentalId}/messages`,
  },
  REVIEWS: {
    CREATE: (rentalId: string) => `/api/rentals/${rentalId}/reviews`,
    BY_USER: (userId: string) => `/api/users/${userId}/reviews`,
  },
  CHATBOT: {
    CHAT: '/api/chatbot/chat',
  },
  NOTIFICATIONS: {
    LIST: '/api/notifications',
    MARK_READ: (id: string) => `/api/notifications/${id}/read`,
    MARK_ALL_READ: '/api/notifications/read-all',
  },
} as const;

export const RENTAL_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending Approval',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  ACTIVE: 'Active Rental',
  RETURNED: 'Returned',
  CANCELLED: 'Cancelled',
  DISPUTED: 'Disputed',
};

export const TOOL_CONDITION_LABELS: Record<string, string> = {
  NEW: 'New',
  LIKE_NEW: 'Like New',
  GOOD: 'Good',
  FAIR: 'Fair',
};

export const ANONYMOUS_SESSION_KEY = 'tb_session_id';
export const AUTH_TOKEN_KEY = 'tb_auth_token';
export const REFRESH_TOKEN_KEY = 'tb_refresh_token';
